import { NOTIFICATION_ACTION_TYPES } from '../actions/types';

const initialState = {
  count: 0,
  loading: false,
  error: null,
  /** Incremented on each successful count fetch so Activity can refresh lists */
  syncRevision: 0,
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case NOTIFICATION_ACTION_TYPES.FETCH_NOTIFICATION_COUNT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case NOTIFICATION_ACTION_TYPES.FETCH_NOTIFICATION_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        count: action.payload.count || 0,
        error: null,
        syncRevision: action.payload.skipActivitySync
          ? state.syncRevision || 0
          : (state.syncRevision || 0) + 1,
      };
    case NOTIFICATION_ACTION_TYPES.FETCH_NOTIFICATION_COUNT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case NOTIFICATION_ACTION_TYPES.CLEAR_NOTIFICATION_COUNT:
      return {
        ...state,
        count: 0,
        error: null,
      };
    default:
      return state;
  }
};

export default notificationReducer;

